export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14609.b3d111cc.jpg";